import { useRef } from 'react';
export const useLastDefined = (value) => {
    const lastDefinedRef = useRef(undefined);
    if (value !== undefined && value !== null) {
        lastDefinedRef.current = value;
        return value;
    }
    return lastDefinedRef.current;
};
